import React, { useState, useEffect } from 'react';
import { DateBox } from 'devextreme-react';
import LVButtonAccion from '../Basicos/LVButtonAccion';
import LVCuadricula from '../Compuestos/Complejos/Generales/LVCuadricula';
import { function_ABM_ART_Presentaciones_ListarDeArticulo } from 'neftis7_apicaller/src/funciones/ABM/ART/ABM_ART_Presentaciones';
import { function_ABM_EEX_Clientes_Listar } from 'neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Clientes';
import ComboAbmEexClientes from '../Compuestos/Combos/ComboAbmEexClientes';
import { ABM_EEX_Clientes } from 'neftis7_apicaller';

function LVSelectorClientes({ onSelectedCodigoChange }) {
  const [dataASeleccionar, setDataASeleccionar] = useState([]);
  const [loadingData, setLoadingData] = useState(false);

  const handleSelectorClick = async (codigo, descripcion) => {
    if (onSelectedCodigoChange) {
      onSelectedCodigoChange(codigo, descripcion);
    }
  };

  const handleCancel = () => {
    if (onSelectedCodigoChange) {
      onSelectedCodigoChange("", "");
    }
  };

  const handleOnValueChanged = async (e) => {
    
    if (onSelectedCodigoChange) {
      const resultCliente = await ABM_EEX_Clientes.function_ABM_EEX_Clientes_Leer(e.value)

      onSelectedCodigoChange(resultCliente.data.IdCliente, resultCliente.data.RazonSocial, resultCliente.data.CUIT.replace(/[-.]/g, ''));
    }
  };

  return (

    <div className="LV-Selectores-div">
      <table >
        <tbody>
          <tr>
            <td>
              <ComboAbmEexClientes
                onValueChanged={handleOnValueChanged}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default LVSelectorClientes;